/** Isolated mock inventory for buyer quiz recommendations when live matching is unavailable. */

export const BUYER_RECOMMENDATION_MOCK_VEHICLES = [
  {
    id: "mock-cx5-2021",
    slug: "mazda-cx5-touring-2021",
    make: "Mazda",
    model: "CX-5",
    version: "Touring",
    year: 2021,
    priceCop: 72_000_000,
    mileageKm: 48_000,
    city: "Medellín",
    neighborhood: "El Poblado",
    transmission: "Automática",
    fuel: "Gasolina",
    bodyType: "SUV",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "AutoCentro Mazda",
    dealerVerified: true,
    dealerResponseMinutes: 25,
    lastConfirmedAt: new Date(Date.now() - 2 * 3_600_000).toISOString(),
    fairPriceLabel: "Precio justo",
    riskLevel: "Bajo",
    financingAvailable: true,
  },
  {
    id: "mock-corolla-2020",
    slug: "toyota-corolla-xei-2020",
    make: "Toyota",
    model: "Corolla",
    version: "XEI",
    year: 2020,
    priceCop: 58_000_000,
    mileageKm: 62_000,
    city: "Envigado",
    neighborhood: "Loma del Escobero",
    transmission: "Automática",
    fuel: "Gasolina",
    bodyType: "Sedán",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "Toyota del Sur",
    dealerVerified: true,
    dealerResponseMinutes: 40,
    lastConfirmedAt: new Date(Date.now() - 5 * 3_600_000).toISOString(),
    fairPriceLabel: "Buen precio",
    riskLevel: "Bajo",
    financingAvailable: true,
  },
  {
    id: "mock-duster-2019",
    slug: "renault-duster-intens-2019",
    make: "Renault",
    model: "Duster",
    version: "Intens",
    year: 2019,
    priceCop: 49_500_000,
    mileageKm: 78_000,
    city: "Medellín",
    neighborhood: "Laureles",
    transmission: "Mecánica",
    fuel: "Gasolina",
    bodyType: "SUV",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "Renault Antioquia",
    dealerVerified: true,
    dealerResponseMinutes: 55,
    lastConfirmedAt: new Date(Date.now() - 12 * 3_600_000).toISOString(),
    fairPriceLabel: "Precio justo",
    riskLevel: "Medio",
    financingAvailable: true,
  },
  {
    id: "mock-ranger-2018",
    slug: "ford-ranger-xlt-2018",
    make: "Ford",
    model: "Ranger",
    version: "XLT",
    year: 2018,
    priceCop: 95_000_000,
    mileageKm: 92_000,
    city: "Rionegro",
    neighborhood: null,
    transmission: "Automática",
    fuel: "Diesel",
    bodyType: "Pickup",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "Ford Oriente",
    dealerVerified: true,
    dealerResponseMinutes: 35,
    lastConfirmedAt: new Date(Date.now() - 8 * 3_600_000).toISOString(),
    fairPriceLabel: "Precio justo",
    riskLevel: "Bajo",
    financingAvailable: false,
  },
  {
    id: "mock-onix-2022",
    slug: "chevrolet-onix-premier-2022",
    make: "Chevrolet",
    model: "Onix",
    version: "Premier",
    year: 2022,
    priceCop: 42_000_000,
    mileageKm: 28_000,
    city: "Sabaneta",
    neighborhood: null,
    transmission: "Automática",
    fuel: "Gasolina",
    bodyType: "Hatchback",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "Chevrolet Valle",
    dealerVerified: false,
    dealerResponseMinutes: 90,
    lastConfirmedAt: new Date(Date.now() - 30 * 3_600_000).toISOString(),
    fairPriceLabel: "Revisar precio",
    riskLevel: "Medio",
    financingAvailable: true,
  },
  {
    id: "mock-sportage-2020",
    slug: "kia-sportage-revolution-2020",
    make: "Kia",
    model: "Sportage",
    version: "Revolution",
    year: 2020,
    priceCop: 68_000_000,
    mileageKm: 55_000,
    city: "Medellín",
    neighborhood: "Envigado",
    transmission: "Automática",
    fuel: "Gasolina",
    bodyType: "SUV",
    imageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    dealerName: "Kia Motors Medellín",
    dealerVerified: true,
    dealerResponseMinutes: 30,
    lastConfirmedAt: new Date(Date.now() - 3 * 3_600_000).toISOString(),
    fairPriceLabel: "Precio justo",
    riskLevel: "Bajo",
    financingAvailable: true,
  },
];
